import type { KeyPaths, Wandi18nResource, WandNamespace } from './i18n-resources/resources';

type Node = { [key: string]: string | Node };

//TODO refine this type
//TODO this is provided for convenience and operates on one namespace
export const selectPath = <Ts extends Wandi18nResource<WandNamespace>>(
    translationSource: Ts,
    path: KeyPaths<Ts>,
): string => {
    if (!path) {
        return path;
    }

    const selectionResult = (path as string).split('.').reduce(
        (translationNode: Node | string, segment) => {
            if (typeof translationNode === 'string') {
                //this shouldn't happen - we reached a leaf with path segments remaining
                return translationNode;
            } else {
                return translationNode[segment] || segment;
            }
        },
        translationSource as unknown as Node | string,
    );

    return selectionResult as string;
};
